import VerifyImpersonatePage from "./VerifyImpersonatePage";

export default VerifyImpersonatePage;
